import db from 'db';
import { dispatch } from '../store';
import {
  UPDATE_SESSION_LIST,
  WATCH_SESSION,
  UPDATE_SESSION,
  UPDATE_SESSION_DATA,
  SET_SESSION_TIMESTAMP,
  UPDATE_SESSION_ATTR
} from './constants';
import { ISession } from 'types';
import authStore from '../auth';
import { firebase, storage } from 'core/firebase';
// import { MapPoint } from 'types';
// import simplify from 'simplify-js';

const sortSessions = (s1, s2) => s2.created - s1.created;

// function simplifyGps(data, precision: number): { lat: number, lng: number }[] {
//   return simplify(data, precision).map((p: { x: number, y: number, time: number }) => ({
//     lat: p.x,
//     lng: p.y,
//     time: p.time
//   }));
// }

function convertSessionData(sessionKey, dataKey, data) {
  // let points = [];
  const dataModel = {
    key: sessionKey,
    fullData: {}
  };

  if (data instanceof firebase.firestore.Blob) {
    data = JSON.parse(data._binaryString);
  }

  if (dataKey !== 'gps') {
    if (data.length) dataModel.fullData[dataKey] = data;
  } else {
    let gpsPoints = data.map(([time, lat, lng]) => ({ time, lat, lng }));
    dataModel.gps = {
      points: gpsPoints,
      short: gpsPoints
    };
  }

  return dataModel;
}

let watchingSessionKey;
export async function watchSession(sessionKey: string) {
  if (watchingSessionKey === sessionKey) return;
  watchingSessionKey = sessionKey;
  const doc = db.session.get(sessionKey);
  dispatch(WATCH_SESSION, sessionKey);

  const session = await doc.load();

  if (session.sessionFile) {
    const url = await storage.ref(session.sessionFile.path).getDownloadURL();
    const res = await fetch(url);
    const data = await res.json();
    for (let key in data) {
      dispatch(UPDATE_SESSION_DATA, convertSessionData(sessionKey, key, data[key]));
    }
  } else {
    doc.sessionData.watch().onChildUpdate(async doc => {
      const { file } = doc.data() || {};
      if (!file) return;
      const res = await fetch(`//storage.googleapis.com/${file.bucket}/${file.path}`);
      const data = await res.json();

      dispatch(UPDATE_SESSION_DATA, convertSessionData(sessionKey, doc.key, data || []));
    });
  }

  db.session
    .get(sessionKey)
    .watch()
    .onUpdate(doc => dispatch(UPDATE_SESSION, doc.data()));
}

export function watchSessions(userKey?: string) {
  dispatch(WATCH_SESSION, userKey);
  db.session.watch().onUpdate(col => {
    dispatch(UPDATE_SESSION_LIST, col.listData().sort(sortSessions));
  });
}

export function unwatchSessions() {
  db.session.unwatch();
}

export function updateSession(sessionKey?: string, update: ISession) {
  db.session.get(sessionKey).update(update);
}

export function removeSession(sessionKey?: string) {
  db.session.get(sessionKey).update({ deleted: Date.now(), deletedBy: authStore.getId() });
}

export function setSessionTimestamp(timestamp: number) {
  dispatch(SET_SESSION_TIMESTAMP, timestamp);
}

export async function createSessionFromFile(file: File): Promise<ISession> {
  if (!file) throw new Error('Missing file');
  let key = db.session.getNewKey();
  const convertFile = 'session-file/' + key;
  await storage.ref(convertFile).put(file);
  await db.session.get(key).set({
    converted: false,
    convertFile,
    name: file.name,
    created: Date.now(),
    creator: authStore.getId()
  });

  return { convertFile, key };
}

export async function createSessionAttr(model) {
  if (!model.name) throw new Error('Custom attributes must have name');
  if (!model.merge) throw new Error('Custom attributes merge math');

  return db.sessionAttr.addPromise(model);
}

export function removeSessionAttr(id) {
  db.sessionAttr.get(id).remove();
}

export function updateSessionAttr(id: string, update) {
  console.log('UPDATE SESSION', update);
  update = { ...update };
  delete update.id;
  delete update.data;
  delete update.points;
  db.sessionAttr.get(id).set(update);
}

export function watchSessionAttrs() {
  db.sessionAttr.watch().onChildUpdate(doc => dispatch(UPDATE_SESSION_ATTR, doc.data()));
}

export function reRunConvert(sessionKey: string) {
  db.session.get(sessionKey).update({ runConvert: Date.now() });
}
